"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VInputFieldWithSuggestions = void 0;
var mobx_react_1 = require("mobx-react");
var React = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var style_1 = require("./style");
var FormFieldContainer_1 = require("./FormFieldContainer");
var Validators_1 = require("../Validators");
var mobx_1 = require("mobx");
var styled_components_1 = __importDefault(require("styled-components"));
var Popover = core_1.Popover;
var VInputFieldWithSuggestions = (function (_super) {
    __extends(VInputFieldWithSuggestions, _super);
    function VInputFieldWithSuggestions(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (value) {
            _this.onClickedOption(value);
        };
        _this.allowValueInList = function (item) {
            return !_this.valueField ||
                "".concat(item.label).toUpperCase().includes("".concat(_this.valueField).toUpperCase());
        };
        _this.onChange = function (e) {
            if (_this.props.upperCaseFormat) {
                _this.setState({
                    start: e.target.selectionStart,
                    end: e.target.selectionEnd
                });
            }
            var parsedValue = (_this.props.upperCaseFormat && e.target.value.toString().toUpperCase()) ||
                e.target.value;
            if (_this.props.fieldState) {
                _this.props.fieldState.onChange(parsedValue);
            }
            if (_this.props.onChange) {
                _this.props.onChange(parsedValue);
            }
            if (_this.props.upperCaseFormat) {
                setTimeout(function () {
                    _this.inputRef.current.setSelectionRange(_this.state.start, _this.state.end);
                }, 30);
            }
        };
        _this.onClickedOption = function (value) {
            var parsedValue = (_this.props.upperCaseFormat &&
                "".concat(value || '').toString().toUpperCase()) ||
                "".concat(value || '');
            if (_this.props.fieldState) {
                _this.props.fieldState.onChange(parsedValue);
            }
            if (_this.props.onChange) {
                _this.props.onChange(parsedValue);
            }
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.state = {
            start: 1,
            end: 1,
            displayPopover: false
        };
        _this.inputRef = props.inputRef ? props.inputRef : React.createRef();
        return _this;
    }
    VInputFieldWithSuggestions.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, labelInfo = _a.labelInfo, fieldState = _a.fieldState, leftIcon = _a.leftIcon, size = _a.size, disabled = _a.disabled, inline = _a.inline, type = _a.type, placeholder = _a.placeholder, rightElement = _a.rightElement, round = _a.round, id = _a.id, className = _a.className, layer = _a.layer, fill = _a.fill, noLabel = _a.noLabel, required = _a.required, validators = _a.validators, tipLabel = _a.tipLabel, displayRequired = _a.displayRequired, tooltip = _a.tooltip, onKeyPress = _a.onKeyPress, onBlur = _a.onBlur;
        var rightEl;
        if (!rightElement) {
            rightEl = React.createElement("div", { style: { paddingRight: 10 } });
        }
        if (fieldState) {
            if (required) {
                if (validators && validators.length > 0) {
                    fieldState.validators.apply(fieldState, __spreadArray([Validators_1.Validators.required], validators, false));
                }
                else {
                    fieldState.validators(Validators_1.Validators.required);
                }
            }
            else if (validators && validators.length > 0) {
                fieldState.validators.apply(fieldState, validators);
            }
        }
        return (React.createElement(StyledPopoverContainer, { style: { width: '100%' } },
            React.createElement(Popover, { boundary: "viewport", canEscapeKeyClose: true, hasBackdrop: false, modifiers: {
                    keepTogether: { enabled: true },
                    preventOverflow: { enabled: true }
                }, shouldReturnFocusOnClose: false, position: 'bottom-left', usePortal: true, portalClassName: "foo", enforceFocus: false, minimal: true, content: React.createElement(core_1.Menu, { style: { maxHeight: '220px', overflow: 'auto' } }, (this.props.options &&
                    this.props.options.filter(this.allowValueInList).length > 0 &&
                    this.props.options.filter(this.allowValueInList).map(function (item) { return (React.createElement(core_1.MenuItem, { popoverProps: {
                            hoverCloseDelay: 400,
                            captureDismiss: true
                        }, active: false, disabled: _this.props.disabled, label: item.rep, key: item.value, text: item.label, onClick: function () {
                            _this.handleClick(item.label);
                        } })); })) || (React.createElement(core_1.MenuItem, { popoverProps: {
                        hoverCloseDelay: 400,
                        captureDismiss: true
                    }, active: false, disabled: true, key: 'No Result', text: 'No Result' }))) },
                React.createElement(style_1.StyledInput, { className: className, disabled: disabled, inline: inline, intent: fieldState && fieldState.hasError ? core_1.Intent.DANGER : core_1.Intent.NONE, labelFor: id, labelInfo: labelInfo, layer: layer, fill: fill, noLabel: noLabel, margin: '0 0 2px 0' },
                    React.createElement(FormFieldContainer_1.FormFieldContainer, { required: required || displayRequired, noLabel: noLabel, label: label, fieldState: fieldState, tooltip: tooltip },
                        tipLabel && React.createElement("span", { className: 'tipLabel' }, tipLabel),
                        React.createElement(core_1.InputGroup, __assign({ large: size === 'large', small: size === 'small', rightElement: rightElement || rightEl, name: id, autoComplete: 'off', inputRef: this.inputRef }, {
                            round: round,
                            leftIcon: leftIcon,
                            type: type,
                            disabled: disabled,
                            placeholder: placeholder,
                            id: id
                        }, { onChange: this.onChange, value: this.valueField, onKeyPress: onKeyPress, intent: fieldState && fieldState.hasError
                                ? core_1.Intent.DANGER
                                : core_1.Intent.NONE, style: {
                                paddingRight: 10,
                                textTransform: this.props.upperCaseFormat
                                    ? 'uppercase'
                                    : 'none'
                            }, onPaste: function (e) {
                                var oldValue = e && e.currentTarget && e.currentTarget.value;
                                var newValue = e && e.clipboardData && e.clipboardData.getData('Text');
                                if (_this.props.onPaste) {
                                    _this.props.onPaste(oldValue, newValue);
                                }
                            }, onFocus: function () {
                                _this.setState({ displayPopover: true });
                            }, onBlur: function () {
                                _this.setState({ displayPopover: false });
                                onBlur && onBlur();
                            } })))))));
    };
    Object.defineProperty(VInputFieldWithSuggestions.prototype, "valueField", {
        get: function () {
            if (this.props.fieldState) {
                return this.props.fieldState.value || '';
            }
            if (this.props.value) {
                return this.props.value;
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed
    ], VInputFieldWithSuggestions.prototype, "valueField", null);
    VInputFieldWithSuggestions = __decorate([
        mobx_react_1.observer
    ], VInputFieldWithSuggestions);
    return VInputFieldWithSuggestions;
}(React.Component));
exports.VInputFieldWithSuggestions = VInputFieldWithSuggestions;
var StyledPopoverContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & .bp3-popover-wrapper {\n    width: 100%;\n    & .bp3-popover-target {\n      width: 100%;\n    }\n  }\n"], ["\n  & .bp3-popover-wrapper {\n    width: 100%;\n    & .bp3-popover-target {\n      width: 100%;\n    }\n  }\n"])));
var templateObject_1;
